interface Profile {
  icon: string;
  title: string;
  desc: string;
}

interface CourseForWhoProps {
  forWho: Profile[];
  notForWho?: string[];
}

export default function CourseForWho({ forWho, notForWho = [] }: CourseForWhoProps) {
  return (
    <section className="py-20 px-6 md:px-16 bg-[#f9f8f6]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* For who */}
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-3">Público</p>
            <h2 className="text-3xl md:text-4xl font-light text-black tracking-tight mb-10">
              Este curso é para você?
            </h2>
            <div className="space-y-6">
              {forWho.map((p, idx) => (
                <div key={idx} className="flex items-start gap-5 group">
                  <div className="w-11 h-11 flex items-center justify-center border border-[#b8962e]/30 bg-white shrink-0 group-hover:border-[#b8962e] group-hover:bg-[#b8962e] transition-all duration-300">
                    <i className={`${p.icon} text-[#b8962e] text-lg group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div className="pt-1">
                    <p className="text-black text-sm font-semibold mb-1 tracking-wide">{p.title}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right side */}
          <div className="space-y-8">
            {/* Highlight box */}
            <div className="bg-[#111] p-8">
              <div className="flex items-start gap-4 mb-6">
                <span className="w-10 h-10 flex items-center justify-center shrink-0">
                  <i className="ri-double-quotes-l text-[#b8962e] text-3xl"></i>
                </span>
                <p className="text-white/80 text-sm leading-relaxed italic pt-1">
                  Se você trabalha ou quer trabalhar no varejo e está pronta para parar de improvisar e começar a ter resultados consistentes — este curso foi feito para você.
                </p>
              </div>
              <div className="border-t border-white/10 pt-5 flex items-center gap-3">
                <div className="w-8 h-8 overflow-hidden rounded-full shrink-0">
                  <img
                    src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8"
                    alt="Gleice Lyra"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-white text-xs font-semibold">Gleice Lyra</p>
                  <p className="text-white/40 text-[11px]">Criadora do Método C.A.T</p>
                </div>
              </div>
            </div>

            {/* Not for who */}
            {notForWho.length > 0 && (
              <div className="bg-white border border-gray-100 p-8">
                <p className="text-xs tracking-[0.3em] uppercase text-gray-400 font-medium mb-5">
                  Quem não deve fazer este curso
                </p>
                <ul className="space-y-3">
                  {notForWho.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-xs text-gray-500 leading-relaxed">
                      <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                        <i className="ri-close-line text-gray-300 text-base"></i>
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
